/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SyncInputs */

const en_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const ar_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مزامنة`)
};

const bn_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const de_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const es_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const fr_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const pt_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const zh_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const tr_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const ru_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

const pl_svtag_sync = /** @type {(inputs: Svtag_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SYNC`)
};

/**
* | output |
* | --- |
* | "#SYNC" |
*
* @param {Svtag_SyncInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_sync = /** @type {((inputs?: Svtag_SyncInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SyncInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_sync(inputs)
	if (locale === "bn") return bn_svtag_sync(inputs)
	if (locale === "de") return de_svtag_sync(inputs)
	if (locale === "es") return es_svtag_sync(inputs)
	if (locale === "fr") return fr_svtag_sync(inputs)
	if (locale === "pt") return pt_svtag_sync(inputs)
	if (locale === "zh") return zh_svtag_sync(inputs)
	if (locale === "tr") return tr_svtag_sync(inputs)
	if (locale === "ru") return ru_svtag_sync(inputs)
	if (locale === "pl") return pl_svtag_sync(inputs)
	return en_svtag_sync(inputs)
});